import { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/api';

const usePipelineEvents = (onPipelineUpdate, onConnectionChange) => {
    const eventSourceRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);

    const connect = useCallback(() => {
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
        }

        const token = localStorage.getItem('token');
        if (!token) return;

        // Create EventSource with authentication via URL parameter
        const eventSource = new EventSource(
            `${getApiUrl('/api/pipeline/events')}?token=${encodeURIComponent(token)}`
        );

        eventSource.onopen = () => {
            console.log('SSE connection established');
            if (onConnectionChange) {
                onConnectionChange(true);
            }
        };

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                console.log('SSE message received:', data);
                
                if (data.type === 'pipeline_update' && onPipelineUpdate) {
                    onPipelineUpdate(data.pipelineId, data.data);
                } else if (data.type === 'connected') {
                    console.log('SSE connection established successfully');
                }
            } catch (error) {
                console.error('Error parsing SSE message:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('SSE connection error:', error);
            eventSource.close();
            
            if (onConnectionChange) {
                onConnectionChange(false);
            }
            
            // Reconnect after 5 seconds
            reconnectTimeoutRef.current = setTimeout(() => {
                console.log('Attempting to reconnect SSE...');
                connect();
            }, 5000);
        };

        eventSourceRef.current = eventSource;
    }, [onPipelineUpdate]);

    const disconnect = useCallback(() => {
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
        }
        
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = null;
        }
    }, []);

    useEffect(() => {
        connect();
        
        return () => {
            disconnect();
        };
    }, [connect, disconnect]);

    return { connect, disconnect };
};

export default usePipelineEvents; 